import { createPinia } from 'pinia';
import { createApp } from 'vue';
import {
  ElAlert,
  ElButton,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElOption,
  ElProgress,
  ElSelect,
  ElSkeleton,
  ElTable,
  ElTableColumn,
} from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import './styles/tokens.css';
import './styles/main.css';

const ossHost = 'http://xb-agent-box.oss-cn-hangzhou.aliyuncs.com/image';
const app = createApp(App);
const components = [
  ElAlert,
  ElButton,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElOption,
  ElProgress,
  ElSelect,
  ElSkeleton,
  ElTable,
  ElTableColumn,
];

components.forEach((component) => app.component(component.name!, component));
app.config.globalProperties.ossHost = ossHost;
app.use(createPinia()).use(router).mount('#app');
